import { TRACER_STATUS_CODE } from './tracerStatusCode';
import { TRACER_STATUS_MESSAGE } from './tracerStatusMessage';

const REPORT_TRACE_SCOPE_STATUS = {
    OK: 'OK',
    CANCELLED: 'CANCELLED',
    FREEZED: 'FREEZED',
    API_ERROR: 'API_ERROR',
};

export const reportTraceScopeStatusGetter = span => {
    if (span.status?.message === TRACER_STATUS_MESSAGE.TERMINATE_TRACE_MESSAGE) {
        return REPORT_TRACE_SCOPE_STATUS.FREEZED;
    }

    if (span.status?.message === TRACER_STATUS_MESSAGE.API_ERROR) {
        return REPORT_TRACE_SCOPE_STATUS.API_ERROR;
    }

    // We use UNSET when report fetching skipped
    if (span.status?.code === TRACER_STATUS_CODE.UNSET) {
        return REPORT_TRACE_SCOPE_STATUS.CANCELLED;
    }

    return REPORT_TRACE_SCOPE_STATUS.OK;
};
